import * as Sentry from "@sentry/react";
import ReactDOM from 'react-dom/client'
import {Router} from "./Router";
import {Provider} from "react-redux";
import {store} from "./api/store.ts";
import {AuthGuard} from "./components/auth/AuthGuard.tsx";


Sentry.init({
    dsn: "https://8b7e760ac9b83eb4fc8a4539881b1837@o117480.ingest.us.sentry.io/4507902212898816",
    integrations: [
        Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: false
});


async function enableMocking() {
    if (process.env.NODE_ENV !== 'development') {
        return
    }

    const {worker} = await import('./mocks/browser')

    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    return worker.start()
}

enableMocking().then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
        <AuthGuard>
        <Provider store={store}>
            <Router/>
        </Provider>
        </AuthGuard>
        ,
    )
})

